import { render, staticRenderFns } from "./detail-date.vue?vue&type=template&id=d3c130aa"
import script from "./detail-date.vue?vue&type=script&lang=js"
export * from "./detail-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports